<script>
import MeetingScholarshipAchievementCard from "./MeetingScholarshipAchievementCard.vue";
import PastStudentStatementsApi from "../../Services/Api/MeetingApi/PastStudentStatementsApi";
export default {
  name: "ThePastStatementExpansionPanelContent",

  components: {
    MeetingScholarshipAchievementCard
  },

  props: {
    link: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      achievements: [],
    };
  },

  mounted() {
    this.getStatementAchievements();
  },

  methods: {
    async getStatementAchievements() {
      try {
        const response = await PastStudentStatementsApi.showByUrl(this.link);
        this.achievements = response.data.competition.achievements;
      } catch (err) {
        console.log(err)
      }
    }
  },
}
</script>

<template>
  <v-row
    no-gutters
    class="overflow-y-auto ma-0 pa-0"
    :style="{'height': '40vh'}"
  >
    <v-col
      v-for="item in achievements"
      :key="item.id"
      cols="12"
    >
      <meeting-scholarship-achievement-card
        :achievement="item"
        :is-action-present="false"
        @openAchievement="$emit('openAchievement', $event)"
      />
      <v-divider/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>